import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';


function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history

    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    const [name, setName] = useState("");
    const [cgstRate, setCGstRate] = useState("");
    const [sgstRate, setSGstRate] = useState("");
    const [cess, setCESSRate] = useState("");
    const [hsn, setHSNCode] = useState("");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);


    const fetchtableData = async () => {
        fetchData('CategoryApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Item Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };


    const handleDelete = async () => {
        deleteData('CategoryApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });

    };

    const handleActivate = (itemId) => {
        activateData('CategoryApi', `${itemId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    //unitmaster

    const [selectedProduct, setSelectedProduct] = useState("");
    const [unitOptions, setUnitOptions] = useState([]);
    const [selectedunitType, setSelectedUnitType] = useState("");

    const fetchUnit = async () => {
        try {
            const response = await fetchData('UnitApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setUnitOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleUnitChange = (selectedOption) => {
        setSelectedUnitType(selectedOption);
    };

    useEffect(() => {
        fetchUnit();
    }, []);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addRecord = async (e) => {
        e.preventDefault();



        const CreateData = {
            CompanyId: companyId,
            Name: name,
            UnitId: selectedunitType.value,
            HSNCode: hsn,
            CGST: cgstRate,
            SGST: sgstRate,
            CESS: cess,
            CreatedBy: userId,
            CreatedDate: new Date(),
            CreatedBy: userId,
        };

        postData('CategoryApi', CreateData, token)
            .then((response) => {
                console.log('Category Created success:', response);
                setSuccessMessage("Category Created successfully!");
                setErrorMessage("");
                setCESSRate("");
                setCGstRate("");
                setSGstRate("");
                setHSNCode("");
                setName("");
                fetchtableData();
                setIsModalOpen(false);
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };

    //CATEGORY EDIT 

    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('CategoryApi', `/CategoryDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});



    const updateRecord = async (event) => {
        event.preventDefault();


        try {

            await updateData('CategoryApi', `${updatedData.id}`, updatedData, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
                CommodityCode: '',
                OpeningstockinQTY: '',
                OpeningstockinPackets: '',
                PurchaseRate: '',
                SaleRate: '',
                PurchaseRateinPkt: '',
                SaleRateinpkt: '',
                MRP: '',
                Noofpktinacase: '',
                HSNCode: '', // new feilds
                CGSTRate: '',
                SGSTRate: '',
            });
            fetchtableData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>ITEM</h5>
                {/* {hasCreateMasterPermission && ( */}
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search by Category"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>

                <Tooltip title="Create New Item">

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #16423C,#6A9C89)',
                            //borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '5px'
                        }}
                        onClick={toggleModal}
                    >
                        + Category

                    </Button>

                </Tooltip>
                {/* )} */}

            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px' }}>
                        <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>CATEGORY CREATE</h6>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Category Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}

                                />
                            </div>
                            <div className="w-1/4 mr-2">

                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Unit
                                </label>
                                <Select
                                    value={selectedunitType}
                                    onChange={handleUnitChange}
                                    options={unitOptions}
                                    placeholder="Select Unit"
                                    isSearchable
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">

                            <div className="w-1/10 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    HSNCode
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                    type="text"
                                    name="HSNCode"
                                    placeholder="Enter HSNCode"
                                    value={hsn}
                                    onChange={(e) => setHSNCode(e.target.value)}
                                />
                            </div>


                            <div className="w-1/10 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GST">
                                    CGST %
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                    type="text"
                                    name="CGSTRate"
                                    placeholder="Enter CGST"
                                    value={cgstRate}
                                    onChange={(e) => setCGstRate(e.target.value)}
                                />
                            </div>

                            <div className="w-1/10 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                    SGST %
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                    type="text"
                                    name="SGSTRate"
                                    placeholder="Enter SGSTRate"
                                    value={sgstRate}
                                    onChange={(e) => setSGstRate(e.target.value)}
                                />
                            </div>

                            <div className="w-1/10 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GST">
                                    CESS Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                    type="text"
                                    name="CESSRate"
                                    placeholder="Enter CESS"
                                    value={cess}
                                    onChange={(e) => setCESSRate(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* end here */}
                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                Add Record
                            </button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}



            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'teal' }}>

                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', width: '950px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Item Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: 'white' }}>

                            {filteredData.map(item => (
                                <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>

                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '20%' }}>
                                        <Link to={`/itemDetail/${item.id}`}>
                                            <IconButton>
                                                <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold' }} />
                                            </IconButton>
                                        </Link>
                                        {hasEditMasterPermission && (
                                            // <Link to={`/itemEdit/${item.id}`}>
                                            <IconButton onClick={() => openDetailModal(item.id)}>
                                                <EditIcon style={{ color: 'blueviolet' }} />
                                            </IconButton>
                                            // </Link>
                                        )}
                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))}>
                                                {item.isActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px' }}>
                            <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>CATEGORY EDIT</h6>
                            <div className="w-full mb-4 flex">


                                <div className="w-1/2 mr-2" style={{ width: '80%' }}>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="name"
                                        placeholder="Enter Item name"
                                        value={updatedData.name}
                                        onChange={handleUpdateInputChange}

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Unit
                                    </label>

                                    <Select
                                        value={selectedunitType || (updatedData.unitname ? { value: updatedData.unitId, label: updatedData.unitname } : '')}
                                        onChange={handleUnitChange}
                                        options={unitOptions}
                                        placeholder="Unit"
                                        isSearchable
                                    />
                                </div>

                            </div>

                            <div className="w-full mb-4 flex">
                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                        HSNCode
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                        type="text"
                                        name="hsnCode"
                                        placeholder="Enter HSNCode"
                                        value={updatedData.hsnCode}
                                        onChange={handleUpdateInputChange}
                                    />
                                </div>


                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GST">
                                        CGST %
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                        type="text"
                                        name="cgst"
                                        placeholder="Enter CGST"
                                        value={updatedData.cgst}
                                        onChange={handleUpdateInputChange}
                                    />
                                </div>

                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                        SGST %
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                        type="text"
                                        name="sgst"
                                        placeholder="Enter SGSTRate"
                                        value={updatedData.sgst}
                                        onChange={handleUpdateInputChange}
                                    />
                                </div>
                                <div className="w-1/10 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                        CESS
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                        type="text"
                                        name="cess"
                                        placeholder="Enter CESSRate"
                                        value={updatedData.cess}
                                        onChange={handleUpdateInputChange}
                                    />
                                </div>

                            </div>
                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                {hasEditMasterPermission && (
                                    <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                        Update Record
                                    </button>
                                )}
                                <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModalBranch}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                        {/* end here */}

                    </div>
                )}
            </div>
        </div>
    );
}

export default ItemIndex;

